import React, { Component } from 'react';
import './styles.scss';

type Props = {
  label: string;
  disabled?: boolean;
  value: string | number;
  onValueChange: Function;
  type?: 'text' | 'number' | 'password' | 'email';
};
type State = {};

export default class Input extends Component<Props, State> {
  render() {
    return (
      <div className='sf-input'>
        <label>{this.props.label}</label>
        <input
          value={this.props.value}
          disabled={this.props.disabled}
          type={this.props.type || 'text'}
          onChange={event => {
            this.props.onValueChange(event.target.value);
          }}
          autoComplete='off'
          autoCorrect='off'
        />
      </div>
    );
  }
}
